let navbarSize = 0;

export const registerNavbar = (e: HTMLElement) => {
    navbarSize = parseFloat(window.getComputedStyle(e).height);
}

export const scrollDownByNavbar = () => {
    window.scrollBy({top: -navbarSize});
};